export const isRNWebView = () => {
  return typeof window !== 'undefined' && !!window.ReactNativeWebView;
};
